module.exports = __webpack_public_path__ + "img/icon_ser.51a0469.webp";